module.exports = __webpack_public_path__ + "img/00015.b48fc643.webp";